module.exports = __webpack_public_path__ + "img/zixunzhongxin.61f4d208.png";